/**
 * Normalizes a UTC-stored date-only value (like DOB) to prevent
 * timezone-induced day shifting when displayed in the local timezone.
 *
 * The backend stores date-only values as UTC datetimes (e.g., "1990-06-10T12:00:00Z").
 * When parsed as a JS Date and formatted in a timezone ahead of UTC (e.g., UTC+12),
 * the date can shift to the next day. This function extracts the UTC date components
 * and creates a new local Date with the same year/month/day.
 */
export const normalizeDateOnly = (
  date: Date | string | undefined | null
): Date | undefined => {
  if (!date) return undefined;

  const d = typeof date === "string" ? new Date(date) : date;

  if (isNaN(d.getTime())) return undefined;

  return new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
};
